var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44445 22C1.77222 22 1.19656 21.7604 0.717446 21.2813C0.238335 20.8022 -0.00081274 20.227 2.07508e-06 19.5556V2.44445C2.07508e-06 1.77222 0.239558 1.19656 0.718669 0.717446C1.19778 0.238335 1.77304 -0.00081274 2.44445 2.07508e-06H19.5556C20.2278 2.07508e-06 20.8034 0.239558 21.2826 0.718669C21.7617 1.19778 22.0008 1.77304 22 2.44445V19.5556C22 20.2278 21.7604 20.8034 21.2813 21.2826C20.8022 21.7617 20.227 22.0008 19.5556 22H2.44445ZM3.66667 17.1111H18.3333L13.75 11L10.0833 15.8889L7.33333 12.2222L3.66667 17.1111Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.d00a89c85f41bd7f98b39b0fed5c7199.svg";
export { ForwardRef as ReactComponent };